import { Backdrop, Button, CircularProgress, Grid } from "@mui/material";
import PageLayout from "../common/PageLayout";
import { useLocation } from "react-router-dom";
import { BsArrowRepeat, BsFiles } from "react-icons/bs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { MailLogRepository } from "../repositories/MailLogRepository";
import { MailLogTable } from "./MailLogTable";

export const MailLog = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const [data, setData] = useState();
  const [orderBy, setOrderBy] = useState("dateCreated");
  const [orderDirection, setOrderDirection] = useState("DESC");

  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAll(0, 15);
  }, []);

  const getAll = (page, size) => {
    setLoading(true);
    MailLogRepository.getAll(page, size, orderBy, orderDirection)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching mail logs:", error);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(error)));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleRequeue = (mailLogId) => {
    setSaving(true);
    MailLogRepository.requeue(mailLogId)
      .then(() => {
        getAll(0, data?.size);
      })
      .catch((error) => {
        console.error("Error requeuing mail log:", error);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(error)));
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const handleChangePage = (event, newPage) => {
    getAll(newPage, data?.size);
  };

  return (
    <PageLayout title="Меил лог" Icon={BsFiles} prev={location.pathname}>
      <Grid container style={{ padding: "10px 0" }}>
        <Grid item xs={12}>
          <Button
            onClick={() => getAll(0, 15)}
            color="primary"
            startIcon={<BsArrowRepeat />}
            variant="contained"
          >
            Освежи преглед
          </Button>
        </Grid>
        <Grid
          item
          xs={12}
          style={{ padding: "10px 0", gap: "10px", display: "flex" }}
        >
          <MailLogTable
            data={data}
            loading={loading}
            handleChangePage={handleChangePage}
            handleRequeue={handleRequeue}
          />
        </Grid>
      </Grid>
      {saving && (
        <Backdrop open={saving}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </PageLayout>
  );
};
